import { Map } from 'immutable';

/**
 * ContentUtils
 * utility functions that take some form of content (stations, tracks, playlists, albums, etc)
 * and return something based on type evaluations.
 *
 * @module lib/ContentUtils
 */

/**
 * @param  {Immutable#Map} content - an immutable map
 * @returns {string} - url for content's backstage page
 */
export function getBackstageRouteForContent(content) {
  const baseUrl = '/artist/';
  if (!(content instanceof Map)) {
    return '#';
  }
  if (content.get('stationId')) {
    return baseUrl + `station/${content.get('stationId')}`;
  }
  return '#';
}
